import { generateUtilityClass, generateUtilityClasses } from '@mui/material';
export function getDateRangePickerInputUtilityClass(slot) {
  return generateUtilityClass('MuiDateRangePickerInput', slot);
}
export const dateRangePickerInputClasses = generateUtilityClasses('MuiDateRangePickerInput', ['root']);